export default __webpack_public_path__ + "static/media/1.e1ec4cf7.jpg";